import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        width: '90%',
        margin: '0 auto',
        textAlign: 'center'
    },
    quote: {
        fontFamily: "'Playfair Display', serif",
        fontStyle: 'italic',
        fontSize: '1.5rem',
        color: theme.palette.secondary.dark,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2em'
        },
    },
    quoteMark: {
        color: '#d4002a',
        fontSize: 48,
        lineHeight: '.6em',
        paddingTop: '2.5em',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.9em'
        },
    },
});
  
class Quote extends React.Component {
    render() {
        const { classes, location, name, review } = this.props;
    
        return (
            <div className={classes.root}>
                <Typography variant='h5' className={classes.quote}>
                    {review}
                </Typography>
                <Typography variant='body2'>{name}</Typography>
                <Typography variant='body2' color='primary'>{location}</Typography>
            </div>
        );
    }
}

Quote.propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    review: PropTypes.string.isRequired,
};

export default withStyles(styles)(Quote);